import { BrandingKey } from 'flow/types/EntityKeys';
import { IS_UAE_HOST } from './browser-utils-TW';

interface SSOSettings {
    branding: BrandingKey;
    google: boolean;
    microsoft: boolean;
    oidc: boolean;
}

type BrandKey = keyof typeof electronBrandKeys;
type SSOSources = 'google' | 'microsoft' | 'oidc';

export const electronBrandKeys = {
    telavox: 'branding-1',
    andorra_telecom: 'branding-6',
    voip_unlimited: 'branding-7',
    claro_peru: 'branding-8',
    ping: 'branding-10',
    freepro: 'branding-60',
    alcom: 'branding-237',
    teleproffs: 'branding-273',
    flow: 'branding-2',
    etisalat: 'branding-3',
    flow_uk: 'branding-302',
    rainbow: 'branding-146',
    freeproxpr: 'branding-306',
    techtell: 'branding-305',
    firstcom_uk: 'branding-322',
    tellit: 'branding-354',
    siminn: 'branding-343',
};

const telavoxBrandedSSO: SSOSettings = {
    branding: 'branding-1',
    google: true,
    microsoft: true,
    oidc: true,
};

const settingsForSSO: Partial<Record<BrandKey, SSOSettings>> = {
    alcom: telavoxBrandedSSO,
    andorra_telecom: telavoxBrandedSSO,
    claro_peru: telavoxBrandedSSO,
    etisalat: {
        branding: 'branding-3',
        google: false,
        microsoft: true,
        oidc: false,
    },
    firstcom_uk: {
        branding: 'branding-322',
        google: true,
        microsoft: true,
        oidc: false,
    },
    flow: telavoxBrandedSSO,
    ping: telavoxBrandedSSO,
    rainbow: telavoxBrandedSSO,
    telavox: telavoxBrandedSSO,
    teleproffs: {
        branding: 'branding-273',
        google: true,
        microsoft: true,
        oidc: true,
    },
    voip_unlimited: telavoxBrandedSSO,
} as const;

/* BRAND only exists in the Electron bundle, so web and CTI fall back on the host. */
export const getBrandElectron = () =>
    (process.env.BRAND || (IS_UAE_HOST ? 'etisalat' : 'telavox')) as BrandKey;

export const getHasAnySingleSignOn = () => {
    const settings = settingsForSSO[getBrandElectron()];

    return settings?.google || settings?.microsoft || settings?.oidc;
};

export const getShouldShowSingleSignOnButton = (syncSource: SSOSources) =>
    settingsForSSO[getBrandElectron()]?.[syncSource] || false;

export const getSingleSignOnBrandingKey = (syncSource: SSOSources) => {
    const settings = settingsForSSO[getBrandElectron()];

    if (!settings?.[syncSource]) {
        return null;
    }

    return settings?.branding || 'branding-1';
};

export const isTelavoxBrand = (brandingKey: BrandingKey) => {
    return 'branding-1' === brandingKey;
};

export const isFlowBrand = (brandingKey: BrandingKey) => {
    return 'branding-2' === brandingKey;
};

export const isJscBrand = (brandingKey: BrandingKey) => {
    return 'branding-3' === brandingKey && !IS_UAE_HOST;
};

export const isEtisalatBrand = (brandingKey: BrandingKey) => {
    return 'branding-3' === brandingKey && IS_UAE_HOST;
};

export const isClaroBrand = (brandingKey: BrandingKey) => {
    return 'branding-8' === brandingKey;
};
